<template>
  <div class="menuitems-main restaurant-details">
    <!-- <div
      class="cat-menu-cls"
      :class="newCateClassAdd"
      v-if="is_menu_category && cateMenus && cateMenus.length > 0"
    >
      <nav class="category-menu-item-main">
        <menu-category
          v-for="catmenu in cateMenus"
          :key="catmenu.id"
          :menu="catmenu"
          v-on:setCategoryMenuId="openMenuCategoryList"
          :pagename="pageName"
        ></menu-category>
      </nav>
    </div> -->
    <div
      class="pt-3 pb-3 px-3 bg-white border-bottom-1 deal-for-you-parent"
      v-if="rest_offer && rest_offer.length > 0"
    >
      <h3>{{ $t("Deals for you") }}</h3>
      <div class="deals-for-you-wrapepr" v-if="rest_offer.length > 0">
        <!-- Vue Slick Carousel -->
        <VueSlickCarousel
          :key="dealsKey"
          class="deals-for-you-wrapper"
          :autoplay="true"
          v-bind="OfferList"
        >
          <div v-for="(offer, i) in rest_offer" :key="i" @click="openModal(offer)">
            <div class="slide-item">
              <div class="deals-for-you-slider">
                <div class="deals-for-you-img">
                  <img
                    :src="offer.coupon_image"
                    alt="Logo"
                    @error="imageErrorHandle"
                  />
                </div>
                <div class="deals-for-you-description">
                  <h5>{{ offer.title }}</h5>
                  <p>
                    <span>{{ offer.tag_line }}</span>
                  </p>
                  <!-- <p v-if="timeLeft > 0">ENDS IN: {{ timeRemaining }}</p>
                  <p v-else>Offer has ended</p> -->
                </div>
              </div>
            </div>
          </div>
        </VueSlickCarousel>
      </div>
      <!-- Promocode Modal -->
      <div
        class="modal fade"
        id="dealModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="dealModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header border-0 pb-0">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <!-- <span aria-hidden="true">&times;</span> -->
                <svg
                  fill="#000000"
                  width="25px"
                  height="25px"
                  viewBox="0 0 32 32"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM21.657 10.344c-0.39-0.39-1.023-0.39-1.414 0l-4.242 4.242-4.242-4.242c-0.39-0.39-1.024-0.39-1.415 0s-0.39 1.024 0 1.414l4.242 4.242-4.242 4.242c-0.39 0.39-0.39 1.024 0 1.414s1.024 0.39 1.415 0l4.242-4.242 4.242 4.242c0.39 0.39 1.023 0.39 1.414 0s0.39-1.024 0-1.414l-4.242-4.242 4.242-4.242c0.391-0.391 0.391-1.024 0-1.414z"
                    ></path>
                  </g>
                </svg>
              </button>
            </div>
            <div class="modal-body">
              <div class="promocode-design">
                <div>
                  <h5 class="modal-title" id="dealModalLabel">
                    {{ offerModalData.title }}
                  </h5>
                </div>
                <button class="procode-strip-design">
                  <div class="procode-strip-design-image">
                    <img
                      class="sc-bmzYkS iDTQnO"
                      src="@/assets/img/offer_default.svg"
                      width="16"
                      height="16"
                      alt=""
                    />
                  </div>
                  <div class="promocode-name-wrapper">
                    <div class="promocode-name">
                      {{ offerModalData.coupon_code }}
                    </div>
                  </div>
                </button>
              </div>
              <div class="promocode-description">
                <p>
                  {{ offerModalData.tag_line }}
                </p>
                <div
                  class="promocode-description-list"
                  v-html="offerModalData.description"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="menu-class-sticky">
      <div class="side-bar" id="side-bar">
        <nav class="navigation" id="menulist">
          <ul>
            <li
              class="d-flex align-items-center menu-tag-list"
              v-if="menus.length != 0"
            >
              <button class="btn"><i class="fas fa-bars"></i></button>
              <div
                v-if="menus.length == 0 && is_menu_skel_loader"
                class="skel-loader"
              >
                <skeleton-loader-vue
                  type="string"
                  v-for="mn in 6"
                  :key="mn"
                  width="93px"
                  height="29px"
                  class="menuSkel"
                />
              </div>
              <div
                v-else
                v-for="menu in menus"
                :key="menu.restaurant_menu_id"
                class="cat-list"
                :class="menu.restaurant_menu_id"
              >
                <a
                  href="javascript:void(0);"
                  :id="'menuitem' + menu.restaurant_menu_id"
                  :class="{ active: active_el == menu.restaurant_menu_id }"
                  v-if="menu.item_counts != 0"
                  @click="activeMenu(menu.restaurant_menu_id)"
                  >{{ menu.menu_name }}</a
                >
              </div>
            </li>
            <li @click="filterTagItem('VEG')" class="mouse-hover" :class="tag_array.includes('VEG') ? 'active' : '' ">
              <img src="@/assets/images/veg-sticky.svg" alt="veg" />
              <span>Veg</span>
            </li>
            <li
              class="d-flex align-items-center menu-tag-list mouse-hover"
              @click="filterTagItem('NONVEG')"
              :class="tag_array.includes('NONVEG') ? 'active' : '' "
            >
              <img src="@/assets/images/non-veg-sticky.svg" alt="veg" />
              <span>Non-veg</span>
            </li>
            <li
              class="d-flex align-items-center menu-tag-list mouse-hover"
              @click="filterTagItem('EGG')"
              :class="tag_array.includes('EGG') ? 'active' : '' "
            >
              <img src="@/assets/images/egg-sticky.svg" alt="veg" />
              <span>Egg</span>
            </li>
            <li
              class="d-flex align-items-center menu-tag-list mouse-hover"
              @click="filterTagItem('BESTSELLER')"
              :class="tag_array.includes('BESTSELLER') ? 'active' : '' "
            >
              <img src="@/assets/images/bestsaller-sticky.svg" alt="veg" />
              <span>Bestseller</span>
            </li>
            <li
              class="d-flex align-items-center menu-tag-list mouse-hover"
              v-for="(tag, inx) in item_tags"
              :key="inx"
              @click="filterTagItem(tag.id)"
              :class="tag_array.includes(tag.id) ? 'active' : '' "
            >
              <!-- <img src="@/assets/images/bestsaller-sticky.svg" alt="veg" /> -->
              <span>{{ tag.name }}</span>
            </li>
          </ul>
        </nav>
        <div class="searchbar-item" v-if="menus && menus.length > 0">
          <input
            type="search"
            v-model="search"
            name="search"
            class="srch-itm"
            :placeholder="$t('Search')"
          />
        </div>
      </div>
    </div>
    <div class="main-content d-lg-flex d-block">
      <div class="custom-tabbing">
        <!-- <ul>
          <li class="mb-0" v-for="c in allRestaurantData" :key="getKeyIdName(c.parent_category_id ?? c.restaurant_menu_id)">
            <a class="nav-link" :href="'#' + getKeyIdName(c.parent_category_id ?? c.restaurant_menu_id)">{{ getKeyIdName(c.parent_category_name  ?? c.menu_name)}}</a>
          </li>
        </ul> -->

        <ul class="nav nav-tabs tabs-left sideways border-bottom-0">
          <!-- <li ><a href="#tab1" data-toggle="tab" class="active">Tab1</a></li> -->
          <!-- <li v-for="(c,i) in allRestaurantData" :key="getKeyIdName(c.parent_category_id ?? c.restaurant_menu_id)">
              <a :href="'#' + getKeyIdName(c.parent_category_id ?? c.restaurant_menu_id)" data-toggle="tab" :class="{'active':i==0}">{{ getKeyIdName(c.parent_category_name  ?? c.menu_name) }}</a>
            </li> -->
          <li class="mouse-hover" v-if="quickItems.length > 0">
            <a
              :class="{ active: activeID == 'quickCheckout' }"
              @click="showQuickCheckout"
              >{{ $t("Your Orders and
              Collections") }}</a
            >
          </li>
          <li class="mouse-hover" v-if="this.offers && this.offers.length > 0">
            <a
              v-for="(o, i) in offers"
              :key="i"
              :class="{ active: activeID == o.title + '/_' + o.id }"
              @click="offerItems(o.id, o.title, o.items)"
              v-if="
                o.items.length > 0 &&
                (o.coupon_type == couponTypes.BOGO ||
                  o.coupon_type == couponTypes.FLATPRICE ||
                  o.coupon_type == couponTypes.FLATPERCENTAGE)
              "
              >{{ o.title }}</a
            >
          </li>
          <li class="mouse-hover" v-if="isBestSeller">
            <a
              @click="manageBestSellerRecommanded('best_seller')"
              :class="{ active: activeID == 'best_seller' }"
              >{{ $t("Best Seller") }}</a
            >
          </li>
          <li class="mouse-hover" v-if="isRecomanded">
            <a
              @click="manageBestSellerRecommanded('recommodation')"
              :class="{ active: activeID == 'recommodation' }"
              >{{ $t("Recommodation") }}</a
            >
          </li>

          <li
            v-for="c in itemListData"
            :key="getKeyIdName(c.parent_category_id ?? c.restaurant_menu_id)"
            class="mouse-hover"
          >
            <a
              @click="
                getItemData(
                  getKeyIdName(c.parent_category_id ?? c.restaurant_menu_id)
                )
              "
              :class="{
                active:
                  activeID ==
                  getKeyIdName(c.parent_category_id ?? c.restaurant_menu_id),
              }"
              >{{ getKeyIdName(c.parent_category_name ?? c.menu_name) }}</a
            >
          </li>
        </ul>
      </div>
      <div class="mobile-device-tab">
        <ul class="">
          <li class="mouse-hover" v-if="quickItems.length > 0">
            <a
              :class="{ active: activeID == 'quickCheckout' }"
              @click="showQuickCheckout"
              >{{ $t("Quick Checkout") }}</a
            >
          </li>

          <li class="mouse-hover" v-if="this.offers && this.offers.length > 0">
            <a
              class="ml-1"
              v-for="(o, i) in offers"
              :key="i"
              :class="{ active: activeID == o.title + o.id }"
              @click="offerItems(o.id, o.title, o.items)"
              v-if="
                o.items.length > 0 &&
                (o.coupon_type == couponTypes.BOGO ||
                  o.coupon_type == couponTypes.FLATPRICE ||
                  o.coupon_type == couponTypes.FLATPERCENTAGE)
              "
              >{{ o.title }}</a
            >
          </li>

          <!-- <li ><a href="#tab1" data-toggle="tab" class="active">Tab1</a></li> -->
          <!-- <li v-for="(c,i) in itemListData" :key="getKeyIdName(c.parent_category_id ?? c.restaurant_menu_id)">
              <a :href="'#' + getKeyIdName(c.parent_category_id ?? c.restaurant_menu_id)" data-toggle="tab" :class="{'active':i==0}">{{ getKeyIdName(c.parent_category_name  ?? c.menu_name) }}</a>
            </li> -->
          <li class="mouse-hover" v-if="isBestSeller">
            <a
              @click="manageBestSellerRecommanded('best_seller')"
              :class="{ active: activeID == 'best_seller' }"
              >{{ $t("Best Seller") }}</a
            >
          </li>
          <li class="mouse-hover" v-if="isRecomanded">
            <a
              @click="manageBestSellerRecommanded('recommodation')"
              :class="{ active: activeID == 'recommodation' }"
              >{{ $t("Recommodation") }}</a
            >
          </li>
          <li
            v-for="c in itemListData"
            :key="getKeyIdName(c.parent_category_id ?? c.restaurant_menu_id)"
            class="mouse-hover"
          >
            <a
              @click="
                getItemData(
                  getKeyIdName(c.parent_category_id ?? c.restaurant_menu_id)
                )
              "
              :class="{
                active:
                  activeID ==
                  getKeyIdName(c.parent_category_id ?? c.restaurant_menu_id),
              }"
              >{{ getKeyIdName(c.parent_category_name ?? c.menu_name) }}</a
            >
          </li>
        </ul>
      </div>
      <!-----skeleton Start layout-1---------->
      <div v-if="is_menu_skel_loader" class="menulength" id="itemmenumain">
        <section>
          <div class="media-heading">
            <h4 class="mb-4">
              <skeleton-loader-vue type="string" width="24%" height="20px" />
            </h4>
          </div>
          <div class="media-itms">
            <div class="item_detail" right="true" v-for="prdt in 4" :key="prdt">
              <div class="media">
                <a
                  href="javascript:void(0)"
                  id="element"
                  class="btn btn-default show-modal"
                >
                  <div class="media-body">
                    <h5 class="mt-0 mr-5 item-name">
                      <skeleton-loader-vue
                        type="string"
                        width="24%"
                        height="20px"
                      />
                    </h5>
                    <p class="mb-0 mt-2 item-descr">
                      <skeleton-loader-vue
                        type="string"
                        width="80%"
                        height="20px"
                      />
                    </p>
                    <div class="prc-show">
                      <span class="mt-2 d-inline-block item-price"
                        ><skeleton-loader-vue
                          type="string"
                          width="54px"
                          height="24px"
                      /></span>
                    </div>
                  </div>
                </a>
                <div class="img-btn">
                  <div class="item-img">
                    <skeleton-loader-vue
                      width="120"
                      class="img-cls"
                      style="border-radius: 5px"
                    />
                  </div>
                  <div class="pgnme-cls">
                    <div>
                      <div class="sold-de">
                        <div class="icus">
                          <button class="btn btn-sm">
                            <skeleton-loader-vue
                              type="string"
                              width="50px"
                              height="24px"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <!-- <div class="tab-content">
            <div class="tab-pane active" id="tab1">
              Tab1
            </div>
            <div class="tab-pane" id="tab2">Tab2.</div>
            <div class="tab-pane" id="tab3">Tab3.</div>
            <div class="tab-pane" id="tab4">Tab4.</div>
          </div>   -->
      <!-----skeleton End Start---------->
      <!-----Quick Checkout ---------->
      <div
        class="menulength checkout-main cust-check-main"
        id="itemmenumain"
        v-if="quickItems.length > 0 && activeID == 'quickCheckout'"
      >
        <section class="chkout-sct">
          <div class="media-heading mt-0">
            <h4 class="mb-4">Checkout</h4>
          </div>
          <div class="media-itms">
            <div
              class="item_detail"
              right="true"
              v-for="(item, i) in quickItems"
              :key="i"
            >
              <div class="media">
                <div class="img-btn">
                  <div class="item-img resimg-squre">
                    <img :src="item.image" @error="imageErrorHandle" />
                  </div>
                </div>
                <a
                  href="javascript:void(0)"
                  id="element"
                  class="btn btn-default show-modal"
                >
                  <div class="media-body">
                    <h5 class="mt-0 mr-5 item-name">
                      1 x {{ item.item_name }}
                    </h5>
                    <p class="mb-0 mt-2 item-descr">
                      <span
                        v-html="$auth.setting && $auth.setting.currency"
                        class="currency"
                      ></span
                      >{{ parseFloat(item.price).toFixed(2) }}
                    </p>
                    <div class="prc-show">
                      <span
                        class="mt-2 d-inline-block item-price"
                        v-if="item.customize_type.length > 0"
                        >Customisable</span
                      >
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="itm-footer modal-footer">
            <div class="number d-flex align-items-center">
              <span v-html="$auth.setting.currency" class="currency"></span
              >{{ quickItemPriceTotal }}
            </div>
            <div
              class="ckout btn btn-outline-danger btn-sm"
              @click="quickCheckout()"
            >
              Checkout
            </div>
          </div>
        </section>
      </div>
      <!-----Quick Checkout end---------->
      <!-- <div
        v-if="menus && menus.length > 0 && menusdata.length == 0"
        class="menulength"
        id="itemmenumain"
      >
        <div v-for="menu in filteredData" :key="menu.restaurant_menu_id">
          <section
            :id="'item' + menu.restaurant_menu_id"
            v-if="menu.item_counts != 0"
          >
            <div class="media-heading">
              <h4 class="mb-4">{{ menu.menu_name }}</h4>
            </div>
            <div
              class="media-itms"
              :class="
                'media-itms-theme' +
                (itemlayout == null || itemlayout == '' ? '1' : itemlayout)
              "
            >
              <Product
                v-for="item in menu"
                :key="item.item_id"
                :item="item"
                :right="true"
                :menuId="menu.restaurant_menu_id"
                v-on:openProductDetailModal="openProductDeails"
                :restaurantID="item.restaurant_id"
                :restaurant_on_off="restaurant_on_off"
                :class="item.item_id"
                :pagename="pageName"
                :itemlayout="1"
              ></Product>
            </div>
          </section>
        </div>
      </div> -->
      <!---Category wise Menu item Open--->
      <div
        v-else-if="filterItemList && filterItemList.length != 0"
        class="menulength 777"
        id="itemmenumain"
      >
        <div>
          <section v-for="(d, i) in filterItemList" :key="d.restaurant_menu_id + i">
            <div class="media-heading">
              <h4 class="mb-4">{{ d.menu_name }}</h4>
            </div>
            <div
              class="media-itms"
              :class="
                'media-itms-theme' +
                (itemlayout == null || itemlayout == '' ? '1' : itemlayout)
              "
            >
              <Product
                v-for="(item, inx) in d.menu_item_detail"
                :key="item.item_id + inx + d.menu_name"
                :item="item"
                :right="true"
                :menuId="d.restaurant_menu_id"
                v-on:openProductDetailModal="openProductDeails"
                :restaurantID="item.restaurant_id"
                :restaurant_on_off="'1'"
                :class="item.item_id"
                :pagename="pageName"
                :itemlayout="
                  itemlayout == null || itemlayout == '' ? '1' : itemlayout
                "
              ></Product>
            </div>
          </section>
        </div>
      </div>
      <!---Category wise Menu item Open--->
      <div v-else class="home-res-not-found flex-grow-1">
        <div class="nostr-img-cls" v-if="!is_menu_skel_loader">
          <img src="@/assets/images/no-result.svg" alt="no result foun"/>
          <div class="no-txt-fnd">
            {{ $t("No Item Found Please check other Restaurant") }}
          </div>
        </div>
      </div>
    </div>
    <ProductDetails
      ref="childComponent"
      :restaurantID="restaurantID"
      :restaurant_on_off="'1'"
      :pagename="pageName"
    >
    </ProductDetails>
    <!--Alert Modal start-->
    <AlertModal
      v-if="isAlert"
      :DisplayAlertData="AlertData"
      v-on:modalClose="onModalCloseFun"
    ></AlertModal>
    <!--Alert Modal End-->
  </div>
</template>




<script>
import { mapActions, mapGetters } from "vuex";
import Product from "@/components/Product.vue";
import ProductDetails from "@/components/ProductDetails.vue";
import MenuCategory from "@/components/MenuCategory.vue";
import VueSkeletonLoader from "skeleton-loader-vue";
import AlertModal from "../components/AlertModal.vue";
import { CouponTypes, imageErrorHandle } from "../helper/helper";

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  components: {
    // name: "FreeDeliveryCarousel1",
    Product,
    ProductDetails,
    MenuCategory,
    "skeleton-loader-vue": VueSkeletonLoader,
    AlertModal,
    VueSlickCarousel,
  },
  props: [
    "restaurant_on_off",
    "restautantDetails",
    "allRestaurantData",
    "search_item",
    "offer",
    "best_seller_ids",
    "recommodation_ids",
  ],
  data() {
    return {
      store_data:[],
      item_tags: [],
      tag_array: [],
      imageErrorHandle: imageErrorHandle,
      couponTypes: CouponTypes,
      isBestSeller: false,
      isRecomanded: false,
      rest_offer: [],
      itemListData: [],
      activeID: 0,
      itemList: [],
      menus: [],
      restaurantID: "",
      vendorID: "",
      date: "",
      starttime: "",
      productDetails: { type: Object },
      active_el: 0,
      pendingOfferID: null,
      dealsKey: 0,
      defaultActiveID: null,
      loading: true,
      search: "",
      pageName: "itemslist",
      routerItemId: 0,
      routerItemIdStatus: true,
      is_menu_category: false,
      cateMenus: [],
      menuCategryId: 0,
      is_menu_skel_loader: true,
      menusdata: [],
      isSearchHide: true,
      itemlayout: "1",
      newCateClassAdd: "",
      quickItems: [],
      quickItemPriceTotal: 0,
      isAlert: false,
      AlertData: {},
      tempProduct: {},
      searchType: "",
      offerItemArray: [],
      offerModalData: {},
      OfferList: {
        dots: false,
        arrows: false,
        infinite: true,
        loop: false,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },
        slidesToShow: 3.5,
        slidesToScroll: 3.5,
        initialSlide: 0,
        centerMode: false,
        centerPadding: "40px",
        responsive: [
          {
            breakpoint: 1199, // When the screen width is 768px or greater
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerPadding: "20px",
            },
          },
          {
            breakpoint: 991, // When the screen width is 768px or greater
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1,
              centerPadding: "20px",
            },
          },
          {
            breakpoint: 600, // When the screen width is 480px or less
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: "10px",
            },
          },
        ],
      },
    };
  },
  watch: {
    offers: function () {
      // offers are persisted in store, refresh deals once this restaurant's offers are loaded
      this.rest_offer = [...(this.offers || [])];
      this.dealsKey++; // re-create slider, slick does not re-layout on slide change
      this.setFreeBie();
      this.openPendingOffer();
    },
    search_item: function () {
      this.searchItem();
    },
  },
  computed: {
    // timeRemaining() {
    //   const hours = Math.floor(this.timeLeft / 3600);
    //   const minutes = Math.floor((this.timeLeft % 3600) / 60);
    //   const seconds = this.timeLeft % 60;

    //   // Format the time as "hh:mm:ss"
    //   return `${String(hours).padStart(2, "0")}h : ${String(minutes).padStart(
    //     2,
    //     "0"
    //   )}m : ${String(seconds).padStart(2, "0")}s`;
    // },
    ...mapGetters("product", ["cart", "offers"]),
    ...mapGetters("order", ["isPickupDelivery"]),
    filteredData() {
      return Object.keys(this.menus).reduce((a, cKey) => {
        const data = this.filterValue(this.menus[cKey]);
        if (data != undefined && data.length) {
          let menuName = this.menus[cKey].menu_name;
          a[cKey] = data;
          a[cKey].menu_name = menuName;
          a[cKey].item_counts = this.menus[cKey].item_counts;
          a[cKey].restaurant_menu_id = this.menus[cKey].restaurant_menu_id;
        }
        return a;
      }, {});
    },
    filteredItemData() {
      return Object.keys(this.menusdata).reduce((a, cKey) => {
        const data = this.filterValue(this.menusdata);
        if (data != undefined && data.length) {
          let menuName = this.menusdata.menu_name;
          a = data;
          a.menu_name = menuName;
          a.item_counts = 0; //this.menusdata.item_counts;
          a.restaurant_menu_id = this.menusdata.restaurant_menu_id;
        }
        return a;
      }, {});
    },
    filterItemList(){
      let array  = [...this.itemList];
      this.itemList.length = 0;
      array.forEach((e)=>{
          if(e.menu_item_detail && e.menu_item_detail.length >0){
              this.itemList.push({...e});
          }
      });

      return this.itemList;
    }
  },
  mounted() {
    let routerHasValue = this.$route.hash;
    if (routerHasValue) {
      this.routerItemId = routerHasValue.replace("#item", "");
    }
    this.vendorID = this.$auth.getVendorId();
    this.restaurantID =
      this.restautantDetails && this.restautantDetails.restaurant_id;
    //Get All Products and Menu
    // if (
    //   this.restautantDetails &&
    //   this.$auth.setting &&
    //   this.restautantDetails.item_counts > this.$auth.setting.item_counts
    // ) {
    //   this.isSearchHide = false;

    //   this.getCategoryWiseMenuList();
    // } else {
    this.isSearchHide = true;
    this.getAllProducts();
    // }
    if (this.$auth.user) {
      this.getCheckoutItemList();
    }
    this.itemListData = [...this.allRestaurantData];
    if (this.itemListData?.length > 0) {
      if (this.best_seller_ids && this.best_seller_ids.length > 0) {
        this.isBestSeller = true;
      }
      if (this.recommodation_ids && this.recommodation_ids.length > 0) {
        this.isRecomanded = true;
      }

      let menuID = localStorage.getItem("menuCatID") ?? 0;
      let offerID = localStorage.getItem("menuCatOfferID") ?? 0;
      localStorage.removeItem("menuCatID");
      localStorage.removeItem("menuCatOfferID");
      // offer selected from home page, or no menu selected -> select first sidebar offer.
      // Offers load after this component mounts, so it is applied in the offers watcher.
      if (Number(offerID) > 0) {
        this.pendingOfferID = offerID;
      } else if (Number(menuID) <= 0) {
        this.pendingOfferID = "first";
      }
      if (Number(menuID) <= 0) {
        menuID = this.getKeyIdName(
          this.itemListData[0]?.parent_category_id ??
            this.itemListData[0]?.restaurant_menu_id
        );
      }
      this.getItemData(menuID);
      this.defaultActiveID = this.activeID;

      if (this.offers && this.offers.length > 0) {
        this.rest_offer = [...this.offers]; // remove spreading directly assign -if there is any issue occure
        this.setFreeBie();
      }
    }
  },

  created() {
    document.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    openModal(offferData) {
      this.offerModalData = offferData;
      const modalElement = document.getElementById("dealModal");
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    },
    ...mapActions("product", [
      "getMenuProductList",
      "getQuickItem",
      "addProductToCart",
      "restaurantMenusList",
      "addFreeBieItem",
    ]),
    ...mapActions("restaurant", [
      "getRestaurantMenuCategoryList",
      "getMenuWiseItem",
      "getCategoryWiseMenu",
    ]),
    filterTagItem(typeORId = 0) {
      if(typeORId != 0){
        const index = this.tag_array.findIndex(tag => tag === typeORId);
        if (index !== -1) {
          this.tag_array.splice(index, 1);
        } else {
          this.tag_array.push(typeORId);
        }
      }
      let itemListDataCopy = [];
      if(this.searchType == "OFFER" || this.searchType == 'BESTSELLER' || this.searchType == 'RECOMMODATION'){
        if(this.store_data.length <= 0){
          this.store_data = [...this.itemList];
        }
        itemListDataCopy = [...this.store_data];
      }else{
         itemListDataCopy = [...this.itemListData];
      }
      let id = this.activeID;
      if (itemListDataCopy.length > 0 && this.activeID != "quickCheckout") {
        this.itemList.length = 0;
        itemListDataCopy.forEach((data) => {
          let iD = this.getKeyIdName(
            data?.parent_category_id ?? data?.restaurant_menu_id
          );
          if (this.tag_array.length > 0) {
            if (iD == id) {
              if (data && data.menu_details) {
                  let cloneArray = [...data.menu_details];
                  this.itemList = cloneArray.map((e) => {
                    const updatedDetails = e.menu_item_detail.filter((i) => {
                      const isTagInArray = i.menu_item_tags.some(tag => 
                            this.tag_array.includes(tag.id)
                          );
                          const isTypeMatch = (
                            (i.item_type == 1 && this.tag_array.includes('NONVEG')) ||
                            (i.item_type == 0 && this.tag_array.includes('VEG')) ||
                            (i.item_type == 3 && this.tag_array.includes('EGG')) ||
                            (this.best_seller_ids.includes(Number(i.item_id)) && this.tag_array.includes('BESTSELLER')) 
                          ); 
                         return isTagInArray || isTypeMatch;
                    });
                    return { ...e, menu_item_detail: updatedDetails };
                  });
                  this.is_menu_skel_loader = false;
                  return;
                } else {
                  let cloneArray = [];
                  cloneArray.push(data);
                  this.itemList = cloneArray.map((e) => {

                    const updatedDetails = e.menu_item_detail.filter((i) => {
                          const isTagInArray = i.menu_item_tags.some(tag => 
                            this.tag_array.includes(tag.id)
                          );
                          const isTypeMatch = (
                            (i.item_type == 1 && this.tag_array.includes('NONVEG')) ||
                            (i.item_type == 0 && this.tag_array.includes('VEG')) ||
                            (i.item_type == 3 && this.tag_array.includes('EGG')) ||
                            (this.best_seller_ids.includes(Number(i.item_id)) && this.tag_array.includes('BESTSELLER')) 
                          ); 
                          // ;
                         return isTagInArray || isTypeMatch;
                    });
                    return { ...e, menu_item_detail: updatedDetails };
                  });
                  this.is_menu_skel_loader = false;
                  return;
                }
            }else if(this.searchType == 'BESTSELLER' || this.searchType == 'RECOMMODATION' || this.searchType == 'OFFER'){
                this.itemList = itemListDataCopy.map((e) => {
                  const updatedDetails = e.menu_item_detail.filter((i) => {
                        const isTagInArray = i.menu_item_tags.some(tag => 
                          this.tag_array.includes(tag.id)
                        );
                        const isTypeMatch = (
                          (i.item_type == 1 && this.tag_array.includes('NONVEG')) ||
                          (i.item_type == 0 && this.tag_array.includes('VEG')) ||
                          (i.item_type == 3 && this.tag_array.includes('EGG')) ||
                          (this.best_seller_ids.includes(Number(i.item_id)) && this.tag_array.includes('BESTSELLER')) 
                        ); 
                       return isTagInArray || isTypeMatch;
                  });
                  return { ...e, menu_item_detail: updatedDetails };
                });
                this.is_menu_skel_loader = false;
                return;
            }
            } else {
              if (iD == id) {
                if (data && data.menu_details) {
                  this.itemList = [...data.menu_details];
                  this.is_menu_skel_loader = false;
                  return;
                } else {
                  this.is_menu_skel_loader = false;
                  this.itemList.push(data);
                  return;
                }
              }else{
                if(this.searchType == 'BESTSELLER'){
                  this.manageBestSellerRecommanded('best_seller',1);
                }else if(this.searchType == 'OFFER'){

                  let items = this.offerItemArray;
                  let parts = this.activeID.split("/_");
                  let title = parts[0];
                  let id = parts[1];
                  this.offerItems(id, title, items,1);

                }else if(this.searchType == 'RECOMMODATION'){
                  this.manageBestSellerRecommanded('recommodation',1);
                }
              }
            }
          });
        
      }
    },
    showQuickCheckout() {
      if (this.activeID == "quickCheckout") {
        return;
      }
      this.activeID = "quickCheckout";
      this.itemList.length = 0;
    },
    setFreeBie() {
      var freeBie = [];
      if (this.itemListData.length > 0) {
        freeBie.length = 0;
        this.rest_offer.forEach((e) => {
          if (e.coupon_type == this.couponTypes.FREEBIE) {
            this.itemListData.forEach((data) => {
              if (data && data.menu_details) {
                data.menu_details.forEach((d) => {
                  if (d.menu_item_detail && d.menu_item_detail.length > 0) {
                    d.menu_item_detail.forEach((t) => {
                      if (e.items.includes(Number(t.item_id))) {
                        freeBie.push({
                          ...t,
                          restaurant_menu_id: d.restaurant_menu_id,
                        });
                      }
                    });
                  }
                });
              } else {
                if (data.menu_item_detail && data.menu_item_detail.length > 0) {
                  data.menu_item_detail.forEach((t) => {
                    if (e.items.includes(Number(t.item_id))) {
                      freeBie.push({
                        ...t,
                        restaurant_menu_id: data.restaurant_menu_id,
                      });
                    }
                  });
                }
              }
            });
          }
        });
      }
      this.addFreeBieItem(freeBie);
    },
    getOfferes(itemId) {
      let array = [];
      this.rest_offer.forEach((e) => {
        if (
          e.items.includes(Number(itemId)) &&
          (this.couponTypes.BOGO == e.coupon_type ||
            this.couponTypes.FREEBIE == e.coupon_type ||
            this.couponTypes.FLATPRICE == e.coupon_type ||
            this.couponTypes.FLATPERCENTAGE == e.coupon_type)
        ) {
          array.push({ ...e, item_id: itemId });
        }
      });
      return array;
    },
    searchItem() {
      let id = this.activeID;
      this.is_menu_skel_loader = true;
      let itemListDataCopy = [...this.itemListData];
      if (itemListDataCopy.length > 0 && this.activeID != "quickCheckout") {
        this.itemList.length = 0;
        if (this.searchType == "ITEM") {
          itemListDataCopy.forEach((data) => {
            let iD = this.getKeyIdName(
              data?.parent_category_id ?? data?.restaurant_menu_id
            );
            if (this.search_item != "" && this.search_item != null) {
              if (iD == id) {
                if (data && data.menu_details) {
                  let cloneArray = [...data.menu_details];
                  this.itemList = cloneArray.map((e) => {
                    const updatedDetails = e.menu_item_detail.filter((i) =>
                      i.item_name
                        .toLowerCase()
                        .includes(this.search_item.toLowerCase())
                    );
                    return { ...e, menu_item_detail: updatedDetails };
                  });

                  // this.itemList = [...data.menu_details];
                  this.is_menu_skel_loader = false;
                  return;
                } else {
                  let cloneArray = [];
                  cloneArray.push(data);
                  this.itemList = cloneArray.map((e) => {
                    const updatedDetails = e.menu_item_detail.filter((i) =>
                      i.item_name
                        .toLowerCase()
                        .includes(this.search_item.toLowerCase())
                    );
                    return { ...e, menu_item_detail: updatedDetails };
                  });

                  this.is_menu_skel_loader = false;
                  // this.itemList.push(data);
                  return;
                }
              }
            } else {
              if (iD == id) {
                if (data && data.menu_details) {
                  this.itemList = [...data.menu_details];
                  this.is_menu_skel_loader = false;
                  return;
                } else {
                  this.is_menu_skel_loader = false;
                  this.itemList.push(data);
                  return;
                }
              }
            }
          });
        } else if (
          this.searchType == "BESTSELLER" ||
          this.searchType == "RECOMMODATION"
        ) {
          let type = this.activeID;
          let object = {};
          object.menu_name =
            type == "best_seller"
              ? this.$t("Best Seller")
              : this.$t("Recommodation");
          object.menu_item_detail = [];
          itemListDataCopy.forEach((data) => {
              if (data && data.menu_details) {
                data.menu_details.forEach((e) => {
                  if (e.menu_item_detail && e.menu_item_detail.length > 0) {
                    e.menu_item_detail.forEach((t) => {
                      if (
                        ((type == "best_seller" &&
                          this.best_seller_ids.includes(Number(t.item_id))) ||
                          (type == "recommodation" &&
                            this.recommodation_ids.includes(
                              Number(t.item_id)
                            ))) &&
                        t.item_name
                          .toLowerCase()
                          .includes(this.search_item.toLowerCase())
                      ) {
                        object.menu_item_detail.push({ ...t });
                      }
                    });
                  }
                });
              } else {

                if (data.menu_item_detail && data.menu_item_detail.length > 0) {
                 data.menu_item_detail.forEach((t) => {
                    if (((type == "best_seller" &&
                          this.best_seller_ids.includes(Number(t.item_id))) ||
                          (type == "recommodation" &&
                            this.recommodation_ids.includes(
                              Number(t.item_id)
                            ))) &&  t.item_name.toLowerCase().includes(this.search_item.toLowerCase())) {
                      object.menu_item_detail.push({ ...t });
                    }
                  });
              }
            }
          });
        this.is_menu_skel_loader = false;

          this.itemList.push(object);
        } else if (this.searchType == "OFFER") {
          let parts = this.activeID.split("/_");
          let title = parts[0];
          let items = this.offerItemArray;
          let object = {};
          object.menu_name = title;
          object.menu_item_detail = [];
          this.itemListData.forEach((data) => {
            if (data && data.menu_details) {
              data.menu_details.forEach((e) => {
                if (e.menu_item_detail && e.menu_item_detail.length > 0) {
                  e.menu_item_detail.forEach((t) => {
                    if (
                      items.includes(Number(t.item_id)) &&
                      t.item_name
                        .toLowerCase()
                        .includes(this.search_item.toLowerCase())
                    ) {
                      object.menu_item_detail.push({ ...t });
                    }
                  });
                }
              });
            } else {
              if (data.menu_item_detail && data.menu_item_detail.length > 0) {
                data.menu_item_detail.forEach((t) => {
                  if (
                    items.includes(Number(t.item_id)) &&
                    t.item_name
                      .toLowerCase()
                      .includes(this.search_item.toLowerCase())
                  ) {
                    object.menu_item_detail.push({ ...t });
                  }
                });
              }
            }
          });
          this.itemList.push(object);
        }
      }
      this.is_menu_skel_loader = false;
    },
    openPendingOffer() {
      if (!this.pendingOfferID) {
        return;
      }
      let pendingOfferID = this.pendingOfferID;
      this.pendingOfferID = null;
      // user already selected another menu before offers loaded
      if (this.activeID != this.defaultActiveID) {
        return;
      }
      // same offers that are listed in sidebar
      let sidebarOffers = (this.offers || []).filter(
        (o) =>
          o.items &&
          o.items.length > 0 &&
          (o.coupon_type == this.couponTypes.BOGO ||
            o.coupon_type == this.couponTypes.FLATPRICE ||
            o.coupon_type == this.couponTypes.FLATPERCENTAGE)
      );
      let offer =
        pendingOfferID == "first"
          ? sidebarOffers[0]
          : sidebarOffers.find((o) => o.id == pendingOfferID);
      if (offer) {
        this.offerItems(offer.id, offer.title, offer.items);
      }
    },
    offerItems(id, title, items,isCall=0) {
      if (this.activeID == title + id && isCall ==0) {
        return;
      }
      this.store_data.length = 0;
      this.searchType = "OFFER";
      this.offerItemArray = items;
      this.is_menu_skel_loader = true;
      this.activeID = title + "/_" + id;
      let object = {};
      this.itemList.length = 0;
      if (this.itemListData.length > 0) {
        object.menu_name = title;
        object.menu_item_detail = [];
        this.itemListData.forEach((data) => {
          if (data && data.menu_details) {
            data.menu_details.forEach((e) => {
              if (e.menu_item_detail && e.menu_item_detail.length > 0) {
                e.menu_item_detail.forEach((t) => {
                  if (items.includes(Number(t.item_id))) {
                    object.menu_item_detail.push({ ...t });
                  }
                });
              }
            });
          } else {
            if (data.menu_item_detail && data.menu_item_detail.length > 0) {
              data.menu_item_detail.forEach((t) => {
                if (items.includes(Number(t.item_id))) {
                  object.menu_item_detail.push({ ...t });
                }
              });
            }
          }
        });
        this.itemList.push(object);
      }
      this.is_menu_skel_loader = false;
      if (this.search_item != "" && this.search_item != null) {
        this.searchItem();
      }
      if(this.tag_array.length > 0){
        this.filterTagItem()
      }
      return;
    },
    manageBestSellerRecommanded(type,iscall=0) {

      if (this.activeID == type && iscall == 0) {
        return;
      }
      this.store_data.length = 0;
      this.is_menu_skel_loader = true;
      this.activeID = type;
      this.searchType = type == "best_seller" ? "BESTSELLER" : "RECOMMODATION";
      let object = {};
      this.itemList.length = 0;
      if (this.itemListData.length > 0) {
        object.menu_name =
          type == "best_seller"
            ? this.$t("Best Seller")
            : this.$t("Recommodation");
        object.menu_item_detail = [];
        this.itemListData.forEach((data) => {
          if (data && data.menu_details) {
            data.menu_details.forEach((e) => {
              if (e.menu_item_detail && e.menu_item_detail.length > 0) {
                e.menu_item_detail.forEach((t) => {
                  if (
                    (type == "best_seller" &&
                      this.best_seller_ids.includes(Number(t.item_id))) ||
                    (type == "recommodation" &&
                      this.recommodation_ids.includes(Number(t.item_id)))
                  ) {
                    object.menu_item_detail.push({ ...t });
                  }
                });
              }
            });
          } else {
            if (data.menu_item_detail && data.menu_item_detail.length > 0) {
              data.menu_item_detail.forEach((t) => {
                if (
                  (type == "best_seller" &&
                    this.best_seller_ids.includes(Number(t.item_id))) ||
                  (type == "recommodation" &&
                    this.recommodation_ids.includes(Number(t.item_id)))
                ) {
                  object.menu_item_detail.push({ ...t });
                }
              });
            }
          }
        });
        this.itemList.push(object);
      }
      this.is_menu_skel_loader = false;
      if (this.search_item != "" && this.search_item != null) {
        this.searchItem();
      }
      if(this.tag_array.length > 0){
        this.filterTagItem()
      }
      return;
    },
    getItemData(id) {
      if (this.activeID == id) {
        return false;
      }
      this.store_data.length = 0;
      this.searchType = "ITEM";
      this.activeID = id;
      this.itemList.length = 0;
      this.is_menu_skel_loader = true;
      let itemListDataCopy = [...this.itemListData];
      if (itemListDataCopy.length > 0) {
        itemListDataCopy.forEach((data) => {
          let iD = this.getKeyIdName(
            data?.parent_category_id ?? data?.restaurant_menu_id
          );
          if (iD == id) {
            if (data && data.menu_details) {
              this.itemList = [...data.menu_details];
              this.is_menu_skel_loader = false;
              return;
            } else {
              this.is_menu_skel_loader = false;
              this.itemList.push(data);
              return;
            }
          }
        });
      } else {
        this.is_menu_skel_loader = false;
      }
      this.is_menu_skel_loader = false;
      this.getTags();
      if (this.search_item != "" && this.search_item != null) {
        this.searchItem();
      }
      if(this.tag_array.length > 0){
        this.filterTagItem()
      }
    },
    getTags() {
      let tags = [];
      let itemListDataCopy = [...this.itemListData];
      if (itemListDataCopy.length > 0) {
        itemListDataCopy.forEach((data) => {
          let iD = this.getKeyIdName(
            data?.parent_category_id ?? data?.restaurant_menu_id
          );
          // if (iD == id) {
          if (data && data.menu_details) {
            data.menu_details.forEach((t) => {
              t.menu_item_detail.forEach((f) => {
                if (f.menu_item_tags.length > 0) {
                  tags = tags.concat(f.menu_item_tags);
                }
              });
            });
          } else {
            data.menu_item_detail.forEach((a) => {
              if (a.menu_item_tags.length > 0) {
                tags = tags.concat(f.menu_item_tags);
              }
            });
          }
          // }
        });

        var array = tags.filter(
          (value, index, self) =>
            index ===
            self.findIndex((t) => t.id === value.id && t.name === value.name)
        );
      }
      this.item_tags = array;
    },
    getKeyIdName(value) {
      return value ? value : "";
    },
    getFilterData(data) {
      if (data && data.menu_details) {
        return data.menu_details;
      } else {
        let array = [];
        array.push(data);
        return array;
      }
    },
    //Search Filter
    filterValue(content) {
      let itemProduct = content.menu_item_detail;
      if (itemProduct) {
        return itemProduct.filter((item) => {
          let itemUpper = item.item_name.toLowerCase();
          let searchUpper = this.search.toLowerCase();
          return itemUpper.indexOf(searchUpper) > -1;
        });
      }
    },

    openMenuCategoryList(id) {
      this.menus = [];
      this.menuCategryId = id;
      this.categoryMenuProduct();
    },

    getAllProducts() {
      if (this.restautantDetails) {
        this.is_menu_category = true;
        this.is_menu_skel_loader = false;
        this.loading = false;
        this.cateMenus = [];
        // this.itemListData= [];

        if (this.itemListData && this.itemListData.length > 0) {
          // this.allRestaurantData.forEach((e) => {
          //   this.cateMenus.push({
          //     id: e.parent_category_id ?? e.restaurant_menu_id,
          //     name: e.parent_category_name ?? e.menu_name,
          //   });
          //   if(e.parent_category_id){
          //     this.itemListData.push({})
          //   }else{
          //   }
          // });
        }
      }
    },

    //Category On click to Get Product
    categoryMenuProduct() {
      this.loading = true;
      this.is_menu_skel_loader = true;
      this.getMenuProductList({
        date: "",
        restaurant_id: this.restaurantID,
        vendor_id: this.vendorID,
        skip: 0,
        starttime: "",
        is_langauge: this.$store.state.lang.locale,
        total_record: 25,
        cityname: "",
        latitude: localStorage.getItem("latitude"),
        delivery_type_time_slots: this.isPickupDelivery,
        menu_category_id: this.menuCategryId,
        longitude: localStorage.getItem("longitude"),
      }).then((data) => {
        if (data.code == 200) {
          this.loading = false;
          this.menus = data.Result;
          let findfirst = this.menus.find((el) => el.item_counts > 0);
          if (findfirst) {
            this.active_el = findfirst.restaurant_menu_id;
          }
          if (this.routerItemId > 0) {
            setTimeout(() => this.activeMenu(this.routerItemId), 1200);
          }
          let element = document.getElementById(
            "menucateID-" + this.menuCategryId
          );
          $(".menucate-cls").removeClass("active");
          if (element != null) {
            element.className += " active";
          }
          this.is_menu_skel_loader = false;
        } else if (data.code == 101) {
          this.menus = [];
          this.is_menu_skel_loader = false;
          this.loading = false;
        } else {
          this.is_menu_skel_loader = false;
          this.loading = false;
        }
      });
    },

    //ProductDetails Popup Modal Open
    openProductDeails(value) {
      window.$("#item-popup").modal("show");
      window.$("#item-popup").on("hidden.bs.modal", () => {
        this.$refs.childComponent.productDetail = null;
        this.$refs.childComponent.selectedCustomisation = {
          customize_type: {},
        };
      });
      this.$refs.childComponent.openProductModel(
        value.item_id,
        value.item_name
      );
    },

    // Active Menu
    activeMenu(itemId) {
      this.$emit("selectMenuCategoryId", itemId);
      let screenWidth = window.screen.width;
      let yOffset = this.getWidthScroll(screenWidth);
      this.active_el = itemId;
      let id = "item" + itemId;
      if (!this.isSearchHide) {
        this.is_menu_skel_loader = true;
        this.menusdata = [];
        this.getMenuWiseItemList(itemId);
      }
      let element = document.getElementById(id);
      if (element) {
        if (this.routerItemId > 0 && this.routerItemIdStatus) {
          this.routerItemIdStatus = false;
          var menuScrollEl = document.getElementById("menuitem" + itemId);
          menuScrollEl.scrollIntoView({ behavior: "smooth" });
          setTimeout(function () {
            let y =
              element.getBoundingClientRect().top +
              window.pageYOffset +
              yOffset;
            window.scrollTo({ top: y, behavior: "smooth" });
          }, 1000);
        } else {
          let y =
            element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }
    },

    //Category Wise Menu Display pagination.
    getCategoryWiseMenuList() {
      if (
        this.restautantDetails &&
        this.restautantDetails.menu_category_count == 0
      ) {
        this.is_menu_category = false;
        this.loading = true;
        this.getCategoryWiseMenu({
          date: "",
          restaurant_id: this.restaurantID,
          vendor_id: this.vendorID,
          starttime: "",
          is_langauge: this.$store.state.lang.locale,
        }).then((data) => {
          if (data.code == 200) {
            this.loading = false;
            this.is_menu_skel_loader = false;
            this.menus = data.Result;
            let findfirst = this.menus.find((el) => el.item_counts > 0);
            if (findfirst) {
              this.active_el = findfirst.restaurant_menu_id;
              this.getMenuWiseItemList(findfirst.restaurant_menu_id);
            }
          } else {
            this.is_menu_skel_loader = false;
            this.loading = false;
          }
        });
      } else if (
        this.restautantDetails &&
        this.restautantDetails.menu_category_count > 0
      ) {
        this.is_menu_category = true;
        this.getRestaurantMenuCategoryList({
          restaurant_id: this.restaurantID,
          vendor_id: this.vendorID,
          is_langauge: this.$store.state.lang.locale,
          latitude: localStorage.getItem("latitude"),
          longitude: localStorage.getItem("longitude"),
        }).then((data) => {
          if (data.code == 200) {
            this.loading = false;
            this.cateMenus = data.Result;
            this.newCateClassAdd = "cateNewClass";
            if (
              localStorage.getItem("menuCatID") == null ||
              localStorage.getItem("menuCatID") == ""
            ) {
              if (this.cateMenus && this.cateMenus[0]) {
                this.menuCategryId = this.cateMenus[0].id;
                this.categoryMenuProduct();
              }
            } else {
              this.openMenuCategoryList(localStorage.getItem("menuCatID"));
              localStorage.setItem("menuCatID", "");
            }
          } else {
            this.is_menu_skel_loader = false;
            this.loading = false;
          }
        });
      }
    },

    //Menu Wise item Display pagination.
    getMenuWiseItemList(itemId) {
      this.is_menu_category = false;
      this.loading = true;
      this.getMenuWiseItem({
        date: "",
        restaurant_id: this.restaurantID,
        vendor_id: this.vendorID,
        skip: 0,
        starttime: "",
        is_langauge: this.$store.state.lang.locale,
        total_record: 25,
        menu_id: itemId,
      }).then((data) => {
        if (data.code == 200) {
          this.loading = false;
          this.is_menu_skel_loader = false;
          this.menusdata = data.Result[0];
        } else {
          this.loading = false;
          this.is_menu_skel_loader = false;
        }
      });
    },

    elementInViewport(el) {
      let top = el.offsetTop;
      var left = el.offsetLeft;
      var width = el.offsetWidth;
      var height = el.offsetHeight;

      let screenWidth = window.screen.width;
      if (screenWidth <= 360) {
        top = top + 425;
      } else if (screenWidth > 360 && screenWidth <= 768) {
        top = top + 500;
      } else if (screenWidth > 768) {
        height = height + 200;
        top = top + 400;
      }
      while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
      }

      return (
        top < window.pageYOffset + window.innerHeight &&
        left < window.pageXOffset + window.innerWidth &&
        top + height > window.pageYOffset &&
        left + width > window.pageXOffset
      );
    },

    handleScroll() {
      document.querySelectorAll("section[id^=item]").forEach((current) => {
        const el = document.getElementById(current.getAttribute("id"));
        if (this.elementInViewport(el)) {
          let scrollmenuid = current.getAttribute("id").replace("item", "");
          if (scrollmenuid) {
            this.active_el = scrollmenuid;
            let menuScrollEl = document.getElementById(
              "menuitem" + scrollmenuid
            );
            if (menuScrollEl) {
              var scrollTo = window
                .$("#menuitem" + scrollmenuid)
                .position().left;
              document.getElementById("menulist").scrollLeft += scrollTo;
            }
          }
        }
      });
    },

    getWidthScroll(screenWidth) {
      let yOffset = 0;
      if (this.itemlayout == 1) {
        if (screenWidth <= 360) {
          yOffset = -180;
        } else if (screenWidth > 360 && screenWidth <= 768) {
          yOffset = -140;
        } else if (screenWidth > 768) {
          yOffset = -150;
        } else {
          yOffset = -150;
        }
      } else if (this.itemlayout == 3) {
        if (screenWidth <= 360) {
          yOffset = -180;
        } else if (screenWidth > 360 && screenWidth <= 768) {
          yOffset = -140;
        } else if (screenWidth > 768) {
          yOffset = -200;
        } else {
          yOffset = -150;
        }
      } else if (this.itemlayout == 2) {
        if (screenWidth <= 360) {
          yOffset = -180;
        } else if (screenWidth > 360 && screenWidth <= 768) {
          yOffset = -180;
        } else if (screenWidth > 768) {
          yOffset = -150;
        } else {
          yOffset = -150;
        }
      }
      return yOffset;
    },

    getCheckoutItemList() {
      this.getQuickItem({
        restaurant_id: this.restaurantID,
        vendor_id: this.vendorID,
        is_langauge: this.$store.state.lang.locale,
        user_id: this.$auth.user.user_id,
      }).then((data) => {
        if (data.code == 200) {
          this.quickItems = data.Result;
          let totalPriceItem = 0;
          this.quickItems.forEach((itm) => {
            totalPriceItem += parseInt(itm.price);
            itm.customize_type.forEach((cust) => {
              cust.option.forEach((opt) => {
                totalPriceItem += parseInt(opt.selection_price);
                opt.options.forEach((opts) => {
                  totalPriceItem += parseInt(opts.selection_price);
                });
              });
            });
          });
          this.quickItemPriceTotal = totalPriceItem;
        } else {
          this.quickItems = [];
        }
      });
    },

    quickCheckout() {
      let arraySelectCustoizeID = [];
      let arraySelectCustoizePrice = [];
      let arraySelectCustoizPackge = [];
      let selected_type = [];
      let packagingCharge = 0;
      let totalItemMrp = 0;
      let totalPriceItem = 0;
      this.$store.commit("product/clearCartItems");
      this.quickItems.forEach((proDetails) => {
        totalItemMrp = 0;
        totalItemMrp += parseInt(proDetails.price);
        let customisation = [];
        proDetails.customize_type.forEach((itm, index) => {
          if (itm.option) {
            let arrangeItem = [];
            itm.option.forEach((itmoption, key) => {
              arrangeItem.push({ id: itmoption.selection_id });
              arraySelectCustoizeID.push(itmoption.selection_id);
              arraySelectCustoizePrice.push(itmoption.selection_price);
              selected_type.push(itmoption.selection_name);
              //arraySelectCustoizPackge.push(parseInt(itmoption.packaging_charge));
              totalItemMrp += parseInt(itmoption.selection_price);

              if (itmoption.options) {
                itmoption.options.forEach((option, okey) => {
                  totalPriceItem += parseInt(option.selection_price);
                  arraySelectCustoizeID.push(option.selection_id);
                  arraySelectCustoizePrice.push(option.selection_price);
                  selected_type.push(option.selection_name);
                  totalItemMrp += parseInt(option.selection_price);
                  //arraySelectCustoizPackge.push(parseInt(option.packaging_charge));
                });
              }
            });
            if (arrangeItem && arrangeItem.length > 0) {
              customisation.push({
                id: itm.customize_type_id,
                selected: arrangeItem,
              });
            }
          }
        });
        packagingCharge = arraySelectCustoizPackge.reduce(
          (partialSum, a) => partialSum + a,
          0
        );
        let savemrp = 0;
        if (proDetails.price < proDetails.mrp) {
          savemrp = proDetails.mrp - proDetails.price;
        }

        let offerArray = [];
        offerArray = this.getOfferes(parseInt(proDetails.item_id));
        if (!this.freeBie) {
          if (offerArray.length > 0) {
            if (offerArray[0].coupon_type == this.couponTypes.FREEBIE) {
              offerArray.length = 0;
            }
          }
        }

        var AddToCartItemArray = {
          restaurant_id: proDetails.restaurant_id,
          item_id: parseInt(proDetails.item_id),
          item_name: proDetails.item_name,
          price: totalItemMrp,
          quantity: 1,
          itemTotalQuantity: proDetails.quantity,
          selected_type: selected_type,
          selectCustoizeID: arraySelectCustoizeID,
          selectCustoizePrice: arraySelectCustoizePrice,
          item_type: proDetails.item_type,
          item_price: proDetails.price,
          image: proDetails.image,
          saveprice: savemrp,
          packageCharge: packagingCharge,
          customisation: customisation || [],
          // offer: this.getOfferes(parseInt(proDetails.item_id)),
          offer: offerArray,
        };
        var checkRestarant = this.cart.find(
          (ele) => ele.restaurant_id == proDetails.restaurant_id
        );
        if (this.cart.length) {
          if (checkRestarant) {
            this.addToCartItem(AddToCartItemArray);
          } else {
            this.AlertData = {
              displayMessage:
                this.$t("Your cart contain items from another ") +
                this.$t(this.$auth && this.$auth.getRestaurantName()) +
                this.$t(
                  "Do you wish to clear cart and start a new order here?"
                ),
              isSetClass: "prdct-modal-cls",
            };
            this.isAlert = true;
            this.tempProduct = AddToCartItemArray;
            window.$("#item-popup").modal("hide");
            window.$(this.$refs.AlertModal).modal();
          }
        } else {
          this.addToCartItem(AddToCartItemArray);
        }
      });
    },

    addToCartItem(product) {
      const cartItemIndex = this.cart.findIndex(
        (item) => parseInt(item.item_id) === parseInt(product.item_id)
      );
      let totalQnt = 0;
      if (cartItemIndex != undefined && cartItemIndex != -1) {
        var itemTotalQuantity = this.cart[cartItemIndex].quantity;
        totalQnt = this.cart[cartItemIndex].quantity + product.quantity;
      } else {
        totalQnt = product.quantity;
      }
      if (totalQnt <= product.itemTotalQuantity) {
        this.$store.dispatch("product/addProductToCart", product);
        this.$router.push({ name: "review-cart" });
      } else {
        //alert(this.$t("Maximum items reached"));
        this.$swal("Chowman", "Maximum items reached");
      }
    },

    onModalCloseFun(value) {
      this.isAlert = false;
      if (value == "yes") {
        this.$store.commit("product/clearCartItems");
        this.addProductCart(this.tempProduct);
      }
    },

    addProductCart(product) {
      let savemrp = 0;
      if (product.price < product.mrp) {
        savemrp = product.mrp - product.price;
      }
      let offerArray = [];
      offerArray = this.getOfferes(product.item_id);
      if (!this.freeBie) {
        if (offerArray.length > 0) {
          if (offerArray[0].coupon_type == this.couponTypes.FREEBIE) {
            offerArray.length = 0;
          }
        }
      }

      var AddToCartItemArray = {
        vendor_id: product.vendor_id,
        restaurant_id: product.restaurant_id,
        item_id: product.item_id,
        item_name: product.item_name,
        price: product.price,
        quantity: 1,
        itemTotalQuantity: product.quantity,
        selected_type: product.selected_type,
        selectCustoizeID: product.selectCustoizeID,
        selectCustoizePrice: product.selectCustoizePrice,
        item_type: product.item_type,
        item_price: product.price,
        image: product.image,
        saveprice: savemrp,
        packageCharge: product.packaging_charge,
        offer: offerArray,
      };

      this.$store.dispatch("product/addProductToCart", AddToCartItemArray);
    },
  },
};
</script>

<style>
.menuSkel {
  border-radius: 30px !important;
}

.skel-loader {
  display: flex;
}

.itm-footer {
  display: flex;
  justify-content: space-between;
}

section.chkout-sct {
  border: 0px solid #ededed;
  border-radius: 7px;
}

p.v-if {
  color: green;
  /* Color for remaining time */
}

p.v-else {
  color: red;
  /* Color for the "Offer has ended" message */
}
</style>
